import { ISidebarNavItem } from "../../components/Navigation/types";

export const getNavItems: (id: string) => Array<ISidebarNavItem> = (
  id: string,
) => {
  // Lazy require to break circular dependency:
  // principal.ts → PrincipalLayout → config.ts → principal.ts
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const routes = require("../../config/router/principal");
  return [
    {
      link: `/principal-database/${id}/profile`,
      label: "profile",
      icon: "profile",
      route: routes.principalDatabaseViewProfile,
    },
    {
      link: `/principal-database/${id}/subscriptions`,
      label: "subscriptions",
      icon: "subscriptions",
      route: routes.principalViewSubscription,
    },
  ];
};
